import React from 'react'
import { StyledContent, StyledLink } from '../components/styles'
import PublicLayout from '../../publicLayout/containers/PublicLayout'
import { RegistrationRequest } from '../components/RegistrationRequest'
import { ROUTES } from '../../navigation'
import { AkaTypography } from 'components'
import { useTranslation } from 'react-i18next'

const RegistrationRequestPage = () => {
	const [t] = useTranslation()
	return (
		<PublicLayout>
			<StyledContent style={{ maxWidth: 500 }}>
				<RegistrationRequest />
				<StyledLink to={ROUTES.login}>
					<AkaTypography variant="bodySegoe" color="primary">
						{t('auth.backToLogin')}
					</AkaTypography>
				</StyledLink>
			</StyledContent>
		</PublicLayout>
	)
}

export default RegistrationRequestPage
